import React, { useMemo } from 'react'
import { getCaseType } from 'Utils';
import { BarList } from './AdminAnalyticsUI';

// Reported cases grouped by case type (was a pie chart)
function ReportsAnalyticsTable({data}) {
  const items = useMemo(() => {
    const counts = {};
    data?.reported?.forEach((r) => {
      const key = r?.caseId?.caseType || 'unknown';
      counts[key] = (counts[key] || 0) + 1;
    });
    return Object.entries(counts).map(([key, value]) => ({ label: key === 'unknown' ? 'Unknown' : (getCaseType(key) || key), value }));
  }, [data]);
  return <BarList items={items} emptyText="No reports in this range" />;
}

export default ReportsAnalyticsTable
